import React from 'react';
import SeeMore from '../SeeMore/SeeMore';

const ReviewCard = props => {
  const { imageURL, reviewTitle, reviewerName } = props;
  const [isImageVisible, showImage] = React.useState(true);
  return (
    <div className="review-card">
      {isImageVisible && (
        <div className="review-card--dp">
          <img src={imageURL} onError={() => showImage(false)} />
        </div>
      )}
      {!isImageVisible && (
        <div className="review-card--dp dummy">{reviewerName[0]}</div>
      )}
      <div className="review-card--details">
        <div className="review-card--details--text">
          <SeeMore rows={3} seeMoreClass="review-card--see-more">
            {reviewTitle}
          </SeeMore>
        </div>
        <div className="review-card--details--reviewer">- {reviewerName}</div>
      </div>
    </div>
  );
};

export default ReviewCard;
